import React, { useState } from 'react'
import Amplify, { API, graphqlOperation, input } from 'aws-amplify'
import { createSubscriber, createZipCode, deleteSubscriber } from './graphql/mutations'
import { getSubscriber, getZipCode } from './graphql/queries'
import './App.css';
import { isValidIowaZip } from './zip';
import PhoneInput from 'react-phone-number-input/input'


import awsExports from "./aws-exports";
Amplify.configure(awsExports);

const initialState = { zip: '', phone: '', range: 30, moreData: "null" }

const App = (props) => {
  const [unsubMode, setUnSubMode] = useState(getInititalStateForUnsub())
  const [formState, setFormState] = useState(initialState)
  // const [success, setSuccses] = useState({ action  : 'unsub', msg: <span><span className="text-pink">Unsubscribed!</span> We hope you got your appointment! Thanks for using <span className="text-pink">Vaccine Buddy!</span></span> })
  const [success, setSuccses] = useState({ msg: "" })
  const [validations, setValidations] = useState([])

  function setInput(key, value) {
    value = value ? value.trim() : value; // trim leading and trailing spaces
    setFormState({ ...formState, [key]: value })
  }

  function getInititalStateForUnsub() {
    return props.params.zip && props.params.phone;
  }

  async function fetchSubsciber(zip, phone) {
    try {
      const res = await API.graphql(graphqlOperation(getSubscriber, { zip: Number.parseInt(zip), phone: phone }))
      return res.data.getSubscriber
    } catch (err) { console.error(`error fetching subscriber phone: ${phone} zip:${zip}`, err, JSON.stringify(err)) }
  }

  function validateForm() {
    let valid = true;
    let msgs = []

    if (!formState.zip) {
      msgs.push("We need your zipcode!")
      setValidations(msgs)
      return false
    }
    if (!isNumeric(formState.zip)) {
      msgs.push("The Zip code does not look valid.")
      setValidations(msgs)
      return false
    }
    if (!isValidIowaZip(Number.parseInt(formState.zip))) {
      msgs.push("The zip code does not seem to be a valid Iowa Zip code.")
      setValidations(msgs)
      return false
    }
    if (!formState.phone) {
      msgs.push("Looks like you forgot to add your Phone number!")
      setValidations(msgs)
      return false
    }
    if (formState.phone.length !== 12) {
      msgs.push("The Phone number does not look right.")
      setValidations(msgs)
      return false
    }
    setValidations(msgs)
    return valid;
  }

  function isNumeric(num) {
    return !isNaN(num)
  }

  async function addSubscriber() {
    try {
      if (!validateForm())
        return

      let existingSub = await fetchSubsciber(formState.zip, formState.phone)
      if (existingSub) {
        setValidations(["Looks like you are already subscibed. Nothing to worry :)"])
        return
      }
      await createNewSubscriber();
    } catch (err) {
      console.error('error creating subscriber:', err, err.message, JSON.stringify(err))
    }
  }

  async function createNewSubscriber() {
    let zipResponse = await API.graphql(graphqlOperation(getZipCode, { zip: Number.parseInt(formState.zip) }));
    if (!zipResponse.data.getZipCode) {
      await API.graphql(graphqlOperation(createZipCode, { input: { zip: formState.zip } }));
    }
    const subscriber = { ...formState };
    setFormState(initialState);
    await API.graphql(graphqlOperation(createSubscriber, { input: subscriber }));
    setSuccses({ action: 'sub', msg: <span><span className="text-pink">Congrats!</span>  You will receive text alerts as soon as any appointments become available within 20 miles of your Zipcode.</span> });
  }

  async function unsubscribe() {
    try {
      const zip = props.params.zip;
      const phone = props.params.phone;
      if (!zip || !phone) {
        console.log("Your link does not look right. You can write to a@mail.com")
        setValidations([{ msg: "Your link does not look right. You can write to a@mail.com" }])
        return
      }
      let sub = await fetchSubsciber(zip, phone)
      if (!sub) {
        console.log("Looks like you are already unsubscribed! ")
        setSuccses({ action: 'unsub', msg: <span><span className="text-pink">Unsubscribed!</span> We hope you got your appointment! Thanks for using <span className="text-pink">Vaccine Buddy!</span></span> })
        return
      }
      await API.graphql(graphqlOperation(deleteSubscriber, { input: { zip: Number.parseInt(zip), phone: phone } }))
      setUnSubMode(false)
      setSuccses({ action: 'unsub', msg: <span><span className="text-pink">Unsubscribed!</span> We hope you got your appointment! Thanks for using <span className="text-pink">Vaccine Buddy!</span></span> })
    } catch (err) {
      console.log('Error unsubscribing. Pleas write to a@mail.com you you continue getting notifications.')
      console.error('error deleting subscriber:. ', err, err.message)
    }
  }

  let validationsDiv = <div>{validations.length > 0 ? validations.map((v, index) => {
    return <div key={index} >
      <span><i className="fa fa-exclamation warning-icon"></i>{v}</span>
    </div>
  }) : ''}</div>

  let mainContent;

  if (success.msg) {
    mainContent = <div className="success-container">
      {success.action === 'sub' ?
        <img className="celebration-icon mtb10" alt="subscribed" src="https://kyp-art.s3-us-west-2.amazonaws.com/conffeti-pops-up.svg"></img> :
        <img className="unsub-icon" alt="unsubscribed" src="https://kyp-art.s3-us-west-2.amazonaws.com/women-finds-appointment.png"></img>
      }
      <div className="success-msg mtb50">{success.msg}</div>
    </div>
  } else {
    if (unsubMode) {
      mainContent = <div className="sub-container">
        <div className="form-title">
          <div className="text-title-secondary">Unsubscribe to phone Notifications</div>
        </div>
        <div className="form">
          <div className="form-row">
            <button className="vb-button mt30 plr40" onClick={unsubscribe}>Unsubscribe</button></div>
        </div>
      </div>
    } else {
      mainContent = <div className="sub-container">
        <div className="form-title">
          <div className="text-title mt10 mb30">Subscribe to Notifications</div>
          <div className="text-regular">Tired of searching COVID-19 vaccine appointments? Simply subscribe to <span className="text-pink">Vaccine Buddy</span> and get text alerts whenever appointments open up as close as 20 miles near you!</div>
        </div>
        <div className="validations">{validationsDiv}</div>
        <form className="form" onSubmit={e => {
          e.preventDefault();
          addSubscriber(e);
        }}>
          <div className="form-row">
            <label htmlFor="zipInput" className="form-label form-control ">Zip</label>
            <input
              id="zipInput"
              onChange={event => setInput('zip', event.target.value)}
              className="form-control"
              value={formState.zip}
              placeholder="Your Iowa Zipcode"
            /></div>
          <div className="form-row">
            <label htmlFor="phoneInput" className="form-label form-control ">Phone</label>
            <PhoneInput
              placeholder="Your Phone Number"
              country="US"
              value={formState.phone}
              onChange={val => setInput('phone', val)} /></div>
          <button className="vb-button mt30" type="submit">Subscribe</button>
        </form>
      </div>
    }
  }



  return (
    <div className="container main-container">

      <div className="header">
        <a className="logolink" href={window.location.protocol + "//" + window.location.host}>
          <img className="logo" src="https://kyp-art.s3-us-west-2.amazonaws.com/vaccine-buddy-logo.png" alt="logo" />
        </a>
      </div>
      <div className="main-content">
        {mainContent}
      </div>
      <div className="footer">
        <span className="footerlink"> Questions/Feedback? <a href="mailto:vaccinebuddyforyou@gmail.com?&amp;subject=VaccineBuddy%20Feedback">Email Us</a></span>
        <span className="footerlink"> <a rel="noopener noreferrer" href="https://www.privacypolicies.com/live/a4f6f009-2817-4f96-8aa8-576521bf8326" target="_blank">Privacy Policy</a></span>
        {success.msg && success.action === 'unsub' ? <span className="footerlink"> Above artwork <a rel="noopener noreferrer" href="https://www.freepik.com/vectors/calendar" target="_blank">www.freepik.com</a></span> : ''}
      </div>
    </div>
  )
}



export default App

